import React from "react";
import { Card, Placeholder } from "react-bootstrap";
import MainCard from "../../Components/Cards/MainCard";

const ForecastingCardSkeleton = () => {
  return (
    <MainCard>
      <Card.Body className="d-flex justify-content-start align-items-center p-0 gap-3">
        {/* Icon Placeholder */}
        <Placeholder
          as="div"
          animation="wave"
          className="rounded bg-secondary"
          style={{ width: "40px", height: "40px" }}
        />

        {/* Text Section */}
        <div className="d-flex flex-column flex-grow-1">
          {/* Value */}
          <Placeholder
            // as="h3"
            animation="wave"
            className="fw-bold mb-1 "
          >
            <Placeholder xs={4} className="" />
          </Placeholder>

          {/* Title */}
          <Placeholder
            // as="p"
            animation="wave"
            className="small mb-0 "
          >
            <Placeholder xs={6} className="" />
          </Placeholder>
        </div>
      </Card.Body>
    </MainCard>
  );
};

export default ForecastingCardSkeleton;
